import answersReducer from "./answersReducer"
import participantsReducer from "./participantsReducer"
import eventReducer from "./eventReducer"
import resultItemsReducer from "./resultItemsReducer"
import questionnaireReducer from "./questionnaireReducer"
import questionsMappingsReducer from "./questionsMappingsReducer"
import questionsReducer from "./questionsReducer"
import resultsReducer from "./resultsReducer"
import userAnswersReducer from "./userAnswersReducer"
import apiPrintReducer from "./apiPrintReducer"
import versionReducer from "./versionReducer"



const rootReducer = {
    apiPrint: apiPrintReducer,
    event: eventReducer,
    questionnaire: questionnaireReducer,
    questions: questionsReducer,
    questionsMappings: questionsMappingsReducer,
    participants: participantsReducer,
    resultItems: resultItemsReducer,
    answers: answersReducer,
    userAnswers: userAnswersReducer,
    results: resultsReducer,
    version: versionReducer
}

export default rootReducer